import { useMemo } from 'react';
import { DisplayField } from '@mews-commander/guest-profile';
import { Optional } from '@mews/std';
import { FieldsGridProps } from '../components';
import { getFieldValue } from '../components/getFieldValue';

type PreSelectedInitialValuesParams = Pick<FieldsGridProps, 'leftProfile' | 'preSelectedFields' | 'rightProfile'>;

export const usePreSelectedInitialValues = ({
    leftProfile,
    preSelectedFields,
    rightProfile,
}: PreSelectedInitialValuesParams) => {
    const defaultValues = useMemo(
        () =>
            preSelectedFields.reduce(
                (acc, { field, profileId }) => {
                    if (profileId) {
                        if (!Object.values(DisplayField).includes(field)) return acc;
                        const profile = profileId === leftProfile.id ? leftProfile : rightProfile;
                        const value = getFieldValue({ profile, fieldName: field });
                        acc[field] = { value };
                    }
                    return acc;
                },
                {} as Record<DisplayField, { value: Optional<string> }>
            ),
        [leftProfile, preSelectedFields, rightProfile]
    );

    return defaultValues;
};
